import jQuery from 'https://cdn.jsdelivr.net/npm/jquery@3.7.1/+esm'
window.jQueryy = jQuery

/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function domReady(fn) {
  if (document.readyState !== 'loading') {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}

function find(iterable) {
  for (let i = 0; i < iterable.length; i++) {
    const value = iterable[i];
    if (value !== undefined) {
      return value;
    }
  }
  return undefined;
}
function each(iterable, fn) {
  for (let i = 0; i < iterable.length; i++) {
    const value = iterable[i];
    fn(value);
  }
}

function parsePriceFromText(text) {
  let price = Number(text.replace(/[^\d\.]/g, ''))

  if (Number.isNaN(price)) {
    return null
  }

  return price
}

function getOptionTextWithNewQty(originalOptionValue, qty, is_label = false) {
  // 'LiftMaster 5 (+ $4.00) Permanent PINs Wireless Keypad KPW5 (+ $119.00)'

  return originalOptionValue.replace(/(\(?\+\s*\$(\d+\.\d+)\)?\s*)$/, (...args) => {
    const basePriceStr = args[2]
    const basePrice = Number(basePriceStr)
    if (Number.isNaN(basePrice)) return args[0]

    if (is_label) {
      return `(+ $${basePriceStr} each)`
    }

    const newPrice = (basePrice * qty).toFixed(2)

    return `(+ $${newPrice})`
    // return `(+ $${basePriceStr} x ${qty})`
  })
}

function onQuantityUpdate(value, qtyInputEl) {
  const root = qtyInputEl.classList.contains('add-quantity') ? qtyInputEl : qtyInputEl.closest('.add-quantity')
  if (!root) return

  if (root.__select) {
    // get the selected option
    each(root.__select.options, opt => {
      if (!opt.value) return

      const originalValue = opt.getAttribute('data-value')
      const text = opt.getAttribute('data-text')

      if (value === 1) {
        opt.value = originalValue
        opt.textContent = originalValue || text
        return
      }

      opt.value = getOptionTextWithNewQty(originalValue, value)
      opt.textContent = getOptionTextWithNewQty(originalValue, value, true)
    })

    return
  }

  if (root.__price_form_input) {
    const basePrice = root.__base_price

    if (value === 1) {
      root.__price_form_input.value = basePrice
      root.__price_textnode.textContent = root.__original_text
      return
    }


    const label = `+ $${(basePrice * value).toFixed(2)}`
    root.__price_form_input.value = label
    root.__price_form_input.value = label
    root.__price_textnode.textContent = `${root.__original_text} each`
    return
  }
}

"Shoppad.apps.infiniteoptions".split(".").reduce(function(o, x) { if (!o[x]) {o[x] ={};} return o[x] }, window);

let totalAddonTypesCount = 0;
let $container = null
let $form = null
let _io_order_group = ''

window.Shoppad.apps.infiniteoptions.beforeReady = function(subscribe) {
  subscribe("appLoad", function (event) {
    // window.Shoppad.apps.infiniteoptions.submitPriceModCartAnyways = true
    console.log("appLoad", event);
    $form  = jQuery(".product-form")
    $form.attr("data-fxinfntoptnqty-infinite-loaded", "true");

    $container = jQuery('#infiniteoptions-container')

    $container.find('.add-quantity').each(function () {
      const select = this.querySelector('select[name^="properties"]')
      if (select) {
        for (let i = 0; i < select.options.length; i++) {
          const opt = select.options[i]
          opt.setAttribute('data-value', opt.value)
          opt.setAttribute('data-text', opt.textContent.trim())
        }

        this.__select = select
      }

      const checkbox = this.querySelector('fieldset label [type="checkbox"]')
      if (checkbox) {
        const textbox = checkbox.nextSibling
        if (textbox) {
          this.__price_textnode = textbox
          this.__original_text = textbox.textContent
          const price = parsePriceFromText(textbox.textContent)
          if (price) {
            this.__base_price = price
          }

          const fieldset  = checkbox.closest('fieldset')
          const formInputEl = fieldset.querySelector('input[name^="properties"]')
          if (formInputEl) {
            this.__price_form_input = formInputEl
          }
        }
      }
    })

    setupLoadingIndicators()

    // if ($container.length) {
    //   $form = $container.closest('.product-form')

    //   let form = $form[0]
    //   let productQtyEl = form.querySelector('[name="quantity"]')
    //   let productQtyElMock = form.querySelector('.fx__product-qty')
    //   if (productQtyEl && productQtyElMock) {
    //     productQtyEl.removeAttribute('name')
    //   }
    // }
  });


  // Fired when an addon is selected.
  subscribe('productBundleAdd', async function(event) {
    console.log('productBundleAdd', event);

    await Promise.resolve();
    totalAddonTypesCount++;

    _io_order_group = event.detail.orderId
    if (jQuery(event.detail.element[0]).parents('.add-quantity').length) {
      // container of `select` and our `quantity selector input`
      const interacted_el = jQuery(event.detail.element[0]).closest('span');

      if (jQuery(interacted_el).children('.fxinfntoptnqty-qty-selector').length) {
        jQuery(interacted_el).children('.fxinfntoptnqty-qty-selector').children('input').attr('name',event.detail.productBundle.variantId);
      }
      else {
        jQuery('#fxinfntoptnqty-cc .fxinfntoptnqty-qty-selector').clone().appendTo(interacted_el).children('input').attr('name',event.detail.productBundle.variantId).attr('data-fxinfntoptnqty-prodname',event.detail.name).attr('data-fxinfntoptnqty-orderid',event.detail.orderId);;
      }
    } else if (jQuery(event.detail.element[0]).hasClass('add-quantity')) {
      const interacted_el_chkbox = jQuery(event.detail.element[0]).children('span');
      jQuery('#fxinfntoptnqty-cc .fxinfntoptnqty-qty-selector').clone().appendTo(interacted_el_chkbox).children('input').attr('name',event.detail.productBundle.variantId).attr('data-fxinfntoptnqty-prodname',event.detail.name).attr('data-fxinfntoptnqty-orderid',event.detail.orderId);
    }

    $form.attr('data-fxinfntoptnqty-qtycount',jQuery('#infiniteoptions-container .fxinfntoptnqty-qty-selector').length);
    $form.attr('data-fxinfntoptnqty-qtycount', totalAddonTypesCount);
  });

  subscribe('productBundleRemove', function(event) {
    console.log('productBundleRemove', event);
    totalAddonTypesCount--;

    const $firstEl = jQuery(event.detail.element[0])

    const $fieldRoot = $firstEl.hasClass('add-quantity') ? $firstEl : $firstEl.parents('.add-quantity')
    if ($fieldRoot && $fieldRoot.length) {
      $fieldRoot.children('span').children('.fxinfntoptnqty-qty-selector').remove();
    }

    if (jQuery('#infiniteoptions-container .fxinfntoptnqty-qty-selector').length > 0) {
      $form.attr('data-fxinfntoptnqty-qtycount',jQuery('#infiniteoptions-container .fxinfntoptnqty-qty-selector').length);
    } else {
      $form.removeAttr('data-fxinfntoptnqty-qtycount');
    }

    if (totalAddonTypesCount > 0) {
      $form.attr('data-fxinfntoptnqty-qtycount', totalAddonTypesCount);
    } else {
      $form.removeAttr('data-fxinfntoptnqty-qtycount');
    }

    const root = $fieldRoot[0]
    root && onQuantityUpdate(1, root)
  });
};

domReady(() => {
  jQuery(document).on("click", ".fxinfntoptnqty-qty-selector button.fxinfntoptnqty-plus", function () {
    const $input = jQuery(this).siblings('input')

    let value = parseInt($input.val()) + 1;
    value = Math.max(1, Number.isNaN(value) ? 0 : value);

    $input.val(value);

    onQuantityUpdate(value, $input[0])
  });

  jQuery(document).on("click", ".fxinfntoptnqty-qty-selector button.fxinfntoptnqty-minus", function () {
    const $input = jQuery(this).siblings('input')

    let value = parseInt($input.val()) - 1;
    value = Math.max(1, Number.isNaN(value) ? 0 : value);

    $input.val(value);

    onQuantityUpdate(value, $input[0])
  });

  jQuery( ".fxinfntoptnqty-sudo-atc" ).one( "click", async function( event ) {

    let variantData = [];
    const form = event.target.closest('form')

    // force form product qty to one
    // if the form quantity is greater than 1, then we get it from other input
    // and add the additional item ourselves
    const selectedVariantId = form ? form.querySelector('[name="id"]').value : null
    let qtyInput = form.querySelector('[name="quantity"]')
    if (qtyInput) {
      qtyInput.value = '1'
    }

    // const qtyInput = form ? form.querySelector('[name="quantity"]') : null
    qtyInput = form ? form.querySelector('.fx__product-qty') : null
    let productQty = qtyInput ? Number(qtyInput.value) : 1
    if (Number.isNaN(productQty)) productQty = 1
    productQty = Math.max(1, productQty)

    jQuery("#infiniteoptions-container .fxinfntoptnqty-qty-selector input").each(function( index ) {
      
      // -1 because the 1 qty is added to cart by the app
      const addonQty = parseInt(jQuery( this ).val()) - 1 ;
      const fx__qtyinput_variantID = parseInt(jQuery( this ).attr('name'));
      const fxinfntoptnqty_order_id = _io_order_group || (_io_order_group = jQuery( this ).attr('data-fxinfntoptnqty-orderid'));
      const fx__qtyinput_prodname = jQuery( this ).attr('data-fxinfntoptnqty-prodname');
      
      if (addonQty > 0) {
        console.log("adding "+ index + ": " + addonQty+ ": " + fx__qtyinput_variantID + "==" + fx__qtyinput_prodname+ "==" + fxinfntoptnqty_order_id);
        variantData.push({
          id: fx__qtyinput_variantID,
          quantity: addonQty,
          properties: { "_io_parent_order_group": fxinfntoptnqty_order_id.toString(), "_io_field_name":fx__qtyinput_prodname}
        })
      } else {
        console.log("Ignoring "+ index + ": " + addonQty+ ": " + fx__qtyinput_variantID );
      }
    });

    if (_io_order_group && productQty > 1) {
      localStorage.setItem('custom:infiniteoptions:product:sync', `${_io_order_group}___${productQty}`);
    }

    
    // Trying to build the same item props as the app is not safe...
    // if (selectedVariantId && productQty >= 2 && _io_order_group) {
      // let productDataProps = {}
      // jQuery("#infiniteoptions-container :is(input[name], select[name])").each(function( index ) {
      //   let label = this.name
      //   if (!label || !label.startsWith('properties[')) {
      //     return
      //   }
      //   label = label.replace('properties[', '')
      //   label = label.slice(0, -1)
      
      //   const value = this.value || ''
        
      //   if (!value && this instanceof HTMLSelectElement) {
      //     return
      //   }

      //   if (label) {
      //     productDataProps[label] = value
      //   }
      // })

      // productDataProps._io_order_group = _io_order_group
      // variantData.push({
      //   id: selectedVariantId,
      //   quantity: productQty - 1,
      //   properties: productDataProps,
      // })
    // }

    if (variantData.length > 0) {
      console.log(`Adding ${variantData.length} items to cart`, variantData);
      await fetch(`${routes.cartAddUrl}`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: variantData })
      })
    }

    setTimeout(() => {
      jQuery('.product-form__add-button').trigger('click');
    })
  });

  jQuery( ".fxsudopaybtns-sudo-atc-sudo" ).on( "click", function( event ) {
    jQuery('.product-form__add-button').trigger('click');
  });

  jQuery(document).on("change", ".spb-select select", function () {
    jQuery(this).children('option[value=""]').removeAttr('disabled');
    if (jQuery(this).find(":selected").val() == '') {
        jQuery(this).parents('.add-quantity').find('.fxinfntoptnqty-qty-selector input[data-fxinfntoptnqty-prodname]').val(1);
    }
  });
});


// -------------------------------------------------------------------
// Loading indicators
// -------------------------------------------------------------------
function setupLoadingIndicators() {
  const productForms = document.querySelectorAll(".product-form");
  productForms.forEach((form) => {
    const buttons = form.querySelectorAll(
      ".fxsudopaybtns-sudo-atc-sudo, .fxsudopaybtns-sudo-atc, .fxinfntoptnqty-sudo-atc, .product-form__add-button"
    );
    const qtyInput = form.querySelector('[name="quantity"]')

    buttons.forEach((button) => {
      button.addEventListener(
        "click",
        (e) => {
          const appLoaded =
            form.getAttribute("data-fxinfntoptnqty-infinite-loaded") ===
            "true";
          if (!appLoaded || totalAddonTypesCount < 1) return;


          if (qtyInput) {
            qtyInput.value = '1'
          }

          buttons.forEach((btn) => {
            btn.classList.add("button--loading");
          });
        },
        { capture: true }
      );
    });
  });
}

